import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type AccountWithSubscriptionType = {
    accountId: string
    name: string
    email: string
    phone: string
    city: string | null
    state: string | null
    isDisabled: boolean
    subscriptionCount: number
}

export const getAccountsWithChargebeeSubscriptions = (): Promise<AccountWithSubscriptionType[]> => {
    return api.get('/v2/subscription-reports/accounts-with-chargebee-subscriptions')
}

export const getAccountsWithChargebeeSubscriptionsQueryOptions = () => {
    return queryOptions({
        queryKey: ['subscription-reports', 'accounts-with-chargebee-subscriptions'],
        queryFn: () => getAccountsWithChargebeeSubscriptions(),
    })
}

type UseAccountsWithChargebeeSubscriptionsOptions = {
    queryConfig?: QueryConfig<typeof getAccountsWithChargebeeSubscriptions>
}

export const useAccountsWithChargebeeSubscriptions = ({ queryConfig }: UseAccountsWithChargebeeSubscriptionsOptions = {}) => {
    return useQuery({
        ...getAccountsWithChargebeeSubscriptionsQueryOptions(),
        ...queryConfig,
    })
}

